import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Car, MapPin, Clock } from 'lucide-react';

const TaxiLouvain = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Taxi Louvain - Chauffeur Privé Luxe | Service VIP 24/7</title>
        <meta name="description" content="Service de taxi privé de luxe à Louvain. Chauffeur professionnel VIP, disponible 24/7. Réservation en ligne instantanée." />
        <meta name="keywords" content="taxi louvain, chauffeur privé louvain, taxi leuven, vtc louvain, transfert louvain" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-louvain" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Taxi Louvain - Chauffeur Privé
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">Service VIP à Louvain (Leuven). Véhicules premium.</p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Louvain" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Taxi Privé de Luxe à Louvain</h2>
          <p className="text-gray-300 mb-4">
            <strong>Taxi Louvain</strong> - Service de chauffeur privé premium pour Louvain (Leuven). 
            Transferts vers Bruxelles, aéroports, université KU Leuven. Disponible 24/7.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Trajets Populaires</h3>
          <ul className="text-gray-300 space-y-2">
            <li>🚗 Louvain → Bruxelles (30 min)</li>
            <li>🚗 Louvain → Aéroport Zaventem (20 min)</li>
            <li>🚗 Louvain → Anvers (45 min)</li>
            <li>🚗 Louvain → Gare de Louvain (5 min)</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TaxiLouvain;